/* eslint-disable @typescript-eslint/indent */
import { useMemo } from 'react';
import { demeterApi } from '../../../Apis/Apis';
import {
    Currency,
    DemeterCommodity,
    DemeterFilterTimeSpan,
    DemeterRegion,
    DemeterSubRegion,
    ListCommodityOtcPricesResponse,
    UnitOfMeasure,
} from '../../../Generated/Raven-Demeter/api';
import CacheKeys from '../../Services/Cache/CacheKeys';
import useCacheThenApi from './useCacheThenApiHook';

export interface IOtcPriceSelection {
    region: DemeterRegion;
    commodity: DemeterCommodity;
    // Only set for commodities that are split by sub region, for example Pan European butter.
    subRegion?: DemeterSubRegion;
    contractYear: number;
    contractMonth: number;
}

// An empty sub region, and All as well, has to be left out of the request completely, otherwise the backend filters every row out.
export const toOtcSubRegion = (subRegion?: string | null): DemeterSubRegion | undefined => {
    if (!subRegion || subRegion === DemeterSubRegion.All) {
        return undefined;
    }

    return subRegion as DemeterSubRegion;
};

const useOtcPricesApi = (
    otcPriceSelection: IOtcPriceSelection,
    currency?: Currency,
    unitOfMeasure?: UnitOfMeasure,
    timeSpan?: DemeterFilterTimeSpan,
): ListCommodityOtcPricesResponse | undefined => {
    const cacheKey = useMemo(() => {
        const cacheKeyPrefix = `${CacheKeys.ListCommodityOtcPrices}`;

        const cacheKeySuffix = JSON.stringify({ ...otcPriceSelection, currency, unitOfMeasure, timeSpan });
        return `${cacheKeyPrefix}_${cacheKeySuffix}`;
    }, [otcPriceSelection, currency, unitOfMeasure, timeSpan]);

    const [, , listCommodityOtcPricesResponse] = useCacheThenApi<ListCommodityOtcPricesResponse>(cacheKey, () =>
        demeterApi.listCommodityOtcPrices(
            otcPriceSelection.region,
            otcPriceSelection.commodity,
            otcPriceSelection.contractYear,
            otcPriceSelection.contractMonth,
            currency,
            otcPriceSelection.subRegion,
            unitOfMeasure,
            timeSpan,
        ),
    );

    return listCommodityOtcPricesResponse;
};

export default useOtcPricesApi;
